<template>
  <Modal v-model="model" sticky reset-drag-position title="编辑级联数据" @on-cancel="cancel"  footer-hide :mask="false" draggable scrollable  class="edit_select_data cascade_config_pop">
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:10%;">序号</th>
            <th class="font_style_set" style="width:25%;" v-if="level!='1'">所属父级</th>
            <th class="font_style_set" style="width:25%;">字典值</th>
            <th class="font_style_set" style="width:30%;">字典备注</th>
            <th class="font_style_set" style="width:10%;border-right: 0px">操作</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" style="max-height: 380px">
        <table class="table_head_footer">
          <tr v-for="(item , index) in dictList" :key="index" :class="{back_color:(index+1)%2==0}">
            <td  style="width:10%;">{{index+1}}</td>
            <td style="width:25%;" v-if="level!='1'">
              <Select v-model="item.parentId" :title="getArrayIndex(higherLevelList,item.parentId)">
                <Option v-for="(parent,parentIndex) in higherLevelList" :value="parent.id" :title="parent.parentName" :key="parentIndex">{{ parent.parentName}}</Option>
              </Select>
            </td>
            <td  style="width:25%;"><Input placeholder="请输入字典值" maxlength="20" style="padding-right:45px" show-word-limit :title="item.cascadeValue" v-model="item.cascadeValue" class="dict_input" ref="dictValue" name="cascadeValue" @change="modifyDictValue(index)"/></td>
            <td  style="width:30%;"><Input placeholder="请输入字典备注" style="padding-right:45px" maxlength="20" show-word-limit v-model="item.cascadeDescr" class="dict_input" ref="cascadeDescr" name="cascadeDescr" @change="modifyDictDescr(index)"/></td>
            <td class="template_table_btn" style="width:10%;"><span class="search_btn" @click="deleteDict(item.id,index)">删除</span></td>
          </tr>
        </table>
      </div>
    </div>
    <Divider orientation="center"><Button type="info" @click="addSelectData">添加</Button></Divider>
    <div class="btn_template" style="margin-top: 24px;">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" :disabled="saveDisabled"  @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "CascadeConfigPop",
    mixins:[publicFunClass],
    props: {
      showDataDictEdit:Boolean,
      dictCode:String,
      moduleId:String,
      cascadeLeave:String
    },
    data(){
      return {
        model:false,
        code:'',
        spinShow:true,
        saveDisabled:false,
        selected:true,
        dictList:[],
        parentId:"",
        level:'',
        higherLevelList:[],
        addData:require('@/assets/image/addData.png'),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
      }
    },
    methods:{
      getArrayIndex:function(arr, obj) {
        let i = arr.length;
        if(i <= 0){
          return "";
        }
        while (i--) {
          if (arr[i].id === obj) {
            return arr[i].parentName;
          }
        }
        return "";
      },
      modifyHigherLevel:function(event){

      },
      modifyDictValue:function(index){
        let name=this.$refs.dictValue[index].name;
        let value=this.$refs.dictValue[index].value;
        this.dictList[index][name]=value;
      },
      modifyDictDescr:function(index){
        let name=this.$refs.cascadeDescr[index].name;
        let value=this.$refs.cascadeDescr[index].value;
        this.dictList[index][name]=value;
      },
      addSelectData:function(){
        let param={
          id:"",
          parentId:"",
          cascadeLeave:this.level,
          cascadeValue:"",
          cascadeDescr:""
        };

      this.dictList.push(param);
      },
      cancel:function(){
        this.$emit("closeDataDictPop",false);
      },
      save:function () {
        for (let i=0;i<this.dictList.length;i++){
          let cascadeValue=this.dictList[i].cascadeValue;
          if(!cascadeValue){
            this.$Modal.info({
              title:'提示',
              content:"序号"+(i+1)+"的字典值不能为空"
            });
            return false;
          };
          if(this.level!='1'){
            let parentId=this.dictList[i].parentId;
              if(!parentId){
                this.$Modal.info({
                  title:'提示',
                  content:"序号"+(i+1)+"的父级不能为空"
                });
                return false;
              }
          };
        }
        let param={
          dictList:JSON.stringify(this.dictList),
          moduleId:this.moduleId,
          customId:this.dictCode,
          journalType:"系统管理=>级联数据设置=>编辑级联值",
          menuId:"3_9-1"
        };
        let that=this;
        this.saveDisabled=true;
        that.$http.post("cascade/updateCascade.json",param) .then(function (res) {
          let result=res.data.flag;
          that.saveDisabled=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.$Message.info("保存成功");
        });
      },
      deleteDict:function (id,index) {
        if(!id){
          this.dictList.splice(index,1);
          this.$Message.info("已删除");
          return false;
        }
        let that=this;
        let param={
          id:id,
          journalType:"系统管理=>级联数据设置=>删除级联值",
          menuId:"null"
        };
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("cascade/deleteCascade.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("删除成功");
              that.initSearch(that.dictCode,that.level);
            });
          }
        });
      },
      initSearch:function (id,cascadeLeave) {
        let that=this;
        let param={
          customId:id,
          cascadeLeave:cascadeLeave,
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("cascade/selectCascades.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.spinShow=false;

          that.higherLevelList = res.data.obj.parentList;
          that.dictList = res.data.obj.list;
        })
      },

    },
    watch:{
      showDataDictEdit:function () {
        this.model=this.showDataDictEdit;
        this.code=this.dictCode;
        this.saveDisabled=false;
        this.level=this.cascadeLeave;
        if(this.showDataDictEdit){
          this.spinShow=true;
          this.initSearch(this.dictCode,this.cascadeLeave);
        }
      }
    }
  }
</script>

<style scoped>
.dict_input /deep/ .ivu-input-word-count{
  background: #ffffff00 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CascadeConfigPop.vue